import { useState } from 'preact/hooks'

/**
 *
 * @param {boolean} defaultState
 */
export const useToggle = (defaultState = false) => {
  const [isActive, setIsActive] = useState(defaultState)
  const handleToggle = () => {
    setIsActive((state) => !state)
  }
  return { isActive, handleToggle }
}
